var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.resourceDetailPage,_vm._b({ref:"detailComponent",tag:"component",on:{"update":function($event){return _vm.$emit('update', $event)}}},'component',_vm.attributes,false))}
var staticRenderFns = []

export { render, staticRenderFns }